module.exports = __webpack_public_path__ + "img/communication17.89d77ddd.png";